import axios from 'axios'
import library from '../../../utils/Library'

export const helpGetUserForOrganization = async (organizationId) => {
  const TOKEN = sessionStorage.getItem('token')

  const URL =
    library.getBaseAPIUrl('organization') +
    '/getAllUsersOrganizationCorpEntities'

  return axios.get(URL, {
    headers: {
      Authorization: `Bearer ${TOKEN}`
    },
    params: {
      organizationId: organizationId
    }
  })
}
